import {useLayoutEffect, useRef} from "react";

/*
 Hook that is executed at every render and set the current attribute
 to true. When unmounted it set the current attribute to false.
 It can be used to check if a component is still mounted before a
 state update.
 */
export default function useMountedRef() {
    const mounted = useRef(false);

    // We use useLayoutEffect so it's called before any useEffect
    useLayoutEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    }, []);

    return mounted;
}